module.exports = __webpack_public_path__ + "img/STX63A.1a4d2ab8.jpg";